import { GET_HOME_PAGE } from './home';
import { GET_NODES_PAGE } from './nodes';
import { GET_REWARDS_PAGE } from './rewards';

export const pageQueries = {
  getHomePage: GET_HOME_PAGE,
  getNodesPage: GET_NODES_PAGE,
  getRewardsPage: GET_REWARDS_PAGE,
};
